// LoaderContext.js
import { createContext, useContext, useState } from 'react';
import { LoadingOverlay } from '@mantine/core';

const LoaderContext = createContext();

export const LoaderProvider = ({ children }) => {
    const [loadingCount, setLoadingCount] = useState(0);

    const showLoader = () => {
        setLoadingCount(prev => prev + 1);
    };

    const hideLoader = () => {
        setLoadingCount(prev => Math.max(0, prev - 1));
    };

    return (
        <LoaderContext.Provider value={{
            isLoading: loadingCount > 0,
            showLoader,
            hideLoader
        }}>
            <LoadingOverlay visible={loadingCount > 0} zIndex={9999} overlayProps={{ radius: 'sm', blur: 2 }} loaderProps={{ color: '#8BC53F', type: 'oval' }} />
            {children}
        </LoaderContext.Provider>
    );
};

export const useLoader = () => useContext(LoaderContext);